  // $(document).ready(function(){
  //       const store_lang = window.Shopify.locale;
  //       var lang = store_lang.toUpperCase();
  //       //console.log("store_lang",lang);
        
  //      $('.popover__choice-list button').on('click', function() {

  //            if(lang == 'EN'){
  //               var userConfirmed = confirm("All selections will be reset. \n Are you sure to reset the filters?");
  //            }else{
  //              var userConfirmed = confirm("Die gesamte Auswahl wird zurückgesetzt. \n Sind Sie sicher, dass Sie die Filter zurücksetzen müssen?");
  //            }
               
  //               if (userConfirmed) {    
  //                 // Add your existing condition or action here
  //                 localStorage.clear(); // Example: clear local storage               
  //                  location.reload(); // Reload the page
  //               } else {
  //                 // If user clicks "Cancel", do nothing
  //                 console.log("User clicked Cancel, action stopped.");
  //                 return false; // Prevent further actions
  //               }
  //         });
  //       });       
$(document).ready(function() {
    const store_lang = window.Shopify.locale;
    const lang = store_lang.toUpperCase();

    $('.popover__choice-list button').on('click', function(e) {
        let userConfirmed;

        if (lang === 'EN') {
            userConfirmed = confirm("All selections will be reset. \n Are you sure to reset the filters?");
        } else {
            userConfirmed = confirm("Die gesamte Auswahl wird zurückgesetzt. \n Sind Sie sicher, dass Sie die Filter zurücksetzen müssen?");
        }

        if (!userConfirmed) {
            e.preventDefault(); // Stop form submission if canceled
            console.log("User clicked Cancel, action stopped.");
            return false;
        }

        // ✅ Clear localStorage BEFORE the form submits
        localStorage.clear();

        // Clean up the URL in the browser bar
        const url = new URL(window.location.href);
        const params = url.searchParams;
        const removableParams = ['style', 'gemstone'];
        removableParams.forEach(param => params.delete(param));
        const cleanedUrl = url.origin + url.pathname + (params.toString() ? '?' + params.toString() : '') + url.hash;

        window.history.replaceState({}, '', cleanedUrl);

        // Clean up the form's action and return_to (if they exist)
        const form = $(this).closest('form');

        // Fix form action URL
        const formAction = form.attr('action');
        if (formAction && formAction.includes('?')) {
            const actionUrl = new URL(formAction, window.location.origin);
            removableParams.forEach(param => actionUrl.searchParams.delete(param));
            form.attr('action', actionUrl.pathname + (actionUrl.search ? '?' + actionUrl.searchParams.toString() : ''));
        }

        // Fix return_to hidden field
        form.find('input[name="return_to"]').each(function() {
            const returnUrl = new URL($(this).val(), window.location.origin);
            removableParams.forEach(param => returnUrl.searchParams.delete(param));
            $(this).val(returnUrl.pathname + (returnUrl.search ? '?' + returnUrl.searchParams.toString() : ''));
        });

        // ✅ Form will now submit as expected with language change
    });
});













